<template>
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
            ref="filterGroup"
            :is-br="false"
            @query="$gjNoticeQuery"
            @reset="$gjReset">
          <gj-radio-group
              v-model="filter.dimension"
              :options="option.dimension"
              @input="inputRadio">
          </gj-radio-group>
          <gj-country-server-select
              v-model="filter.countryMarket"
          ></gj-country-server-select>
          <gj-select
              v-model="filter.type"
              :options="option.type"
              placeholder="类型"
          ></gj-select>
          <gj-select-input
              v-model="filter.keyword"
              :options="option.keyword"
              :width="['100px', '100px']"
          ></gj-select-input>
          <gj-date-picker
              v-model="filter.date"
              type="daterange"
              :max-day-length="15"
              :clearable="false"
              :shortcut="false"
              @input="$gjNoticeQuery"
          ></gj-date-picker>
          <template  #right>
            <gj-tool-group
                v-if="!$permission('operationLog:add')"
                :download="$permission('operationLog:export')" download-url="/operation/operationLog/export" :download-params="globalParams"
                help
            ></gj-tool-group>
            <view-setting
                    :ref="REF_VIEW_SETTING"
                    save-mode="remote"
                    :use-default="true"
                    :module-name="moduleName"
                    :config="model"
                    :fn-generate-params="generateViewParams"
                    @view-change="handleChangeView"
                    @view-complete="handCompleteView"
            >
            </view-setting>
          </template>
        </app-filter-group>
      </template>
      <template v-if="$permission('operationLog:add')" #operate-group>
        <gj-button
            type="primary"
            @click="add()">
          添加日志
        </gj-button>
      </template>
      <template v-if="$permission('operationLog:add')" #tool-group>
        <gj-tool-group
            :download="$permission('operationLog:export')" download-url="/operation/operationLog/export" :download-params="globalParams"
            help
        ></gj-tool-group>
      </template>
      <template #table>
        <gj-table
            ref="gjTable"
            adaptParent
            name="operationLog"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            :show-overflow="false"
            size="has-picture"
            :pagination="pagination"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
          <template v-slot:asin="{row}">
            <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
          </template>
          <template v-for="(column, i) in dateColumns"
                    v-slot:[column.header]="{row}">
            <div :key="column.id">
              <template v-if="row[column.header] && row[column.header].length > 0">
                <div v-for="(item, j) in row[column.header]"
                     :key="j">
                  <gj-tooltip
                      :text-line="2"
                      :content="item.content">
                    <span class="gj-table--label">[{{item.type}}]</span>
                    <span>{{item.content}}</span>
                  </gj-tooltip>
                </div>
              </template>
              <template v-else>-</template>
            </div>
          </template>
          <template v-slot:op="{row}">
            <gj-button
                type="text"
                @click="view(row)">
              查看详情
            </gj-button>
          </template>
        </gj-table>
      </template>
    </app-base-main>
</template>

<script>
  import {queryMixin} from "../../../../minxins";
  import {OperationLogEnum} from "./common/enum";
  import {exportFile, getDictionaryCombobox} from "../../../../api/common";
  import {subDays, addDays, differenceInDays} from 'date-fns';
  import {convertToDate, generateViewParams } from "../../../../utils/date.util";
  import {countryMarketParams, defaultVal, isMeaningful} from "../../../../utils/common";
  import {mapGetters} from "vuex";
  import {getOperationLogPage} from "../../../../api/sale";
  import model from './viewConfig'
  import AppAddOperationLogModal from "./modal/add/add-operation-log-modal";
  import AppViewOperationLogModal from "./modal/view/view-operation-log-modal";
  import AppViewOperationLogHeader from "./modal/view/components/view-operation-log-header";

  export default {
    name: "app-operation-log",
    mixins: [queryMixin],
    data() {
      return {
        tableData: [],
        columns: [],
        dateColumns: [],
        filter: {
          dimension: OperationLogEnum.dimension.ASIN,
          countryMarket: null,
          type: null,
          keyword: {
            key: 'asin',
            value: null,
          },
          date: [subDays(new Date(), 14), new Date()]
        },
        option: {
          dimension: OperationLogEnum.dimensionOption,
          type: [],
          typeLoading: false,
          keyword: [],
        },
        OperationLogEnum: OperationLogEnum,
        moduleName: 'OPERATION_LOG',
        model,
        // 缓存配置项
        cacheOptions: {
          useCache: true,
        }
      }
    },
    created() {
      this.getTypeOption();
      this.sort.prop = 'updateTime';
      
    },
    watch: {
      'option.type': {
        handler(val) {
          this.model = model.bind(this, val)
        }
      },
      'filter.dimension': {
        handler: function (dimension) {
          if (dimension === 'Asin') {
            this.option.keyword = [
              {id: 'asin', text: 'ASIN'},
              {id: 'variationAsin', text: '父ASIN'},
            ];
          } else {
            this.option.keyword = [
              {id: 'asin', text: 'ASIN'},
            ];
            this.filter.keyword.key = 'asin';
          }
        },
        immediate: true
      },
      column: {
        handler: function ({dimension, date}) {
          const asinDimension = dimension === 'Asin';
          const columns = [
            {id: 'marketId', header: '店铺/国家', field: 'option:marketId', width: '120px', options: () => this.marketOption, fixed: 'left'},
            asinDimension ? {id: 'picture', header: '图片', field: 'picture:imageUrl', width: '50px', fixed: 'left'} : null,
            asinDimension ? {id: 'asin', header: 'ASIN', field: 'slot:asin', minWidth: '120px', fixed: 'left'} : null,
            {id: 'variationAsin', header: '父ASIN', field: 'variationAsin', minWidth: '120px', fixed: 'left'},
            {id: 'op', header: '操作', field: 'slot:op', width: '90px', fixed: 'right', notCustomColumn: true},
          ].filter(e => isMeaningful(e));
          const dateColumns = [];
          // 日期字段
          const range = differenceInDays(date[1], date[0]);
          for (let i = 0; i <= range; i++) {
            const dateStr = convertToDate(addDays(date[0], i));
            dateColumns.push({
              id: dateStr,
              header: dateStr,
              field: `slot:${dateStr}`,
              minWidth: '180px'
            });
          }
          this.dateColumns = this._.orderBy(dateColumns, ['id'], ['desc']);
          this.columns = columns.concat(this.dateColumns);
        },
        immediate: true
      }
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
      column() {
        return {
          dimension: this.filter.dimension,
          date: this.filter.date,
        }
      }
    },
    methods: {
      inputRadio() {
        // this.$refs.filterGroup.cacheDataFn()
        this.$gjNoticeQuery()
      },
      /**
       * 设置全局查询参数
       */
      mergeRemoteParams (params) {
        const date = params.date ? params.date : (params.startDateTime && params.endDateTime ? [params.startDateTime, params.endDateTime] : this.filter.date)
        this.filter = Object.assign({}, this.filter, {
          ...params,
          date
        })
      },
      generateViewParams,
     
      loadViewComplete () {
        this.$emit('query')
      },
      $gjQueryInitParams() {
        return {
          filter: {
            dimension: OperationLogEnum.dimension.ASIN,
            countryMarket: null,
            type: null,
            keyword: {
              key: 'asin',
              value: null,
            },
            date: [subDays(new Date(), 14), new Date()]
          },
        };
      },
      /**
       *
       * @param params 查询条件参数
       * @override queryMixin
       * @returns {{countryMarketValue: *}}
       */
      $gjCacheCallback() {
        return {
          // type: params.type,
          dimension: this.filter.dimension,
          countryMarket: this.filter.countryMarket
        };
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            dimension: this.filter.dimension,
            type: defaultVal(this.filter.type),
            startLogDate: convertToDate(this.filter.date[0]),
            endLogDate: convertToDate(this.filter.date[1]),
            ...countryMarketParams(this.filter.countryMarket, {
              countryKey: 'countrys',
              marketKey: 'marketIds'
            }),
          },
          ...this.queryPagination,
          ...this.querySort
        };
        params.model[this.filter.keyword.key] = this.filter.keyword.value;
        this.globalParams = params;
        // 查询
        this.loading = true;
        getOperationLogPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data.records.map(item => {
                if (isMeaningful(item.logDateCols)) {
                  for (let key in item.logDateCols) {
                    item[key] = item.logDateCols[key];
                  }
                }
                return item;
              });
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
      getTypeOption() {
        this.option.typeLoading = true;
        getDictionaryCombobox('OPERATION_LOG_TYPE')
          .then((data) => {
            this.option.type = data;
          })
          .complete(() => this.option.typeLoading = false);
      },
      add() {
        this.$gjCreate(AppAddOperationLogModal, {
          on: {
            created: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      view(row) {
        this.$gjCreate(AppViewOperationLogModal, {
          props: {
            header: () => ({
              component: AppViewOperationLogHeader,
              props: {
                dimension: this.filter.dimension,
                variationAsin: row.variationAsin,
                asin: row.asin,
                marketId: row.marketId,
                imageUrl: row.imageUrl,
              }
            }),
            dimension: this.filter.dimension,
            marketId: row.marketId,
            asin: row.asin,
            variationAsin: row.variationAsin,
            countryCode: row.countryCode,
          },
          on: {
            updated: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      download() {
        exportFile('/operation/operationLog/export', this.globalParams);
      }
    }
  }
</script>

<style scoped>

</style>





























